import axios from 'axios';
import { logoutUser } from '../ReduxStore/userReducer';
import { resetItemGroup, resetItems } from '../ReduxStore/actions';

export const PostData = async (PostAPI, data, jwtToken, dispatch, navigate) => {
    // Function to extract error messages from nested error objects
    const extractErrorMessage = (errorObject) => {
        for (const key in errorObject) {
            if (Array.isArray(errorObject[key])) {
                return errorObject[key].join(', ');
            }
            if (typeof errorObject[key] === "object") {
                const nestedError = extractErrorMessage(errorObject[key]);
                if (nestedError) {
                    return nestedError;
                }
            }
        }
        return "An unknown error occurred.";
    };
    const api = PostAPI;

    try {
        const response = await axios.post(PostAPI, data, {
            headers: {
                'wg_token': jwtToken,
            },
        });
        return response.data;
    } catch (error) {
        // Handle SAP and normal errors
       
        if (error.response && error.response.data) {
            const sapError =
                error.response.data.errors && error.response.data.errors.length
                    ? error.response.data.errors[0]
                    : error.response.data;
            // Extract the error message
            let errorMessage;
            if (typeof sapError === "object") {
                errorMessage = extractErrorMessage(sapError);
            } else {
                errorMessage = sapError;
            }
            // Handle 401 Unauthorized error (Invalid token)
            if (error.response.status === 401 || error.response.data === 'Invalid token') {
                dispatch(logoutUser());
                dispatch(resetItemGroup());
                dispatch(resetItems());
                navigate('/');
            }

            // Re-throw the error with a meaningful message
            throw new Error(errorMessage);
        } else {
            // Handle unexpected errors
            throw new Error("An unexpected error occurred.");
        }
    }
};

export const PostWithoutData = async (PostAPI, jwtToken, dispatch, navigate) => {

        try {
            const response = await axios.post(PostAPI,null, {
                headers: {
                    'wg_token': jwtToken,
                },
            });
            return response.data;
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.data === 'Invalid token')) {
                dispatch(logoutUser());
                dispatch(resetItemGroup());
                dispatch(resetItems());
                navigate('/');
            }
            throw error;
        }
    };
    
